export default function (language) {
  var server = 'https://mam.zuerich.com/anura/internet'
  var locale = language
  var node = { id: [2928, 24] }

  var basket = $('#anura-basket').anuraBasket({
    server: server,
    locale: locale,
    terms_and_conditions: {
      title: {
        de: 'Gerne informieren wir Sie nachfolgend über die Nutzungsbestimmungen des Zürich Tourismus Media Centers',
        en: "We are pleased to inform you below about the Zürich Tourism Center's Conditions of Use",
      },
      message: {
        de:
          'Im Zürich Tourismus Media Center stehen Ihnen alle Bilder, Videos und Audiodateien für eine redaktionelle ' +
          'Nutzung kostenlos zur Verfügung. Für Veröffentlichungen ist die Quellenangabe «© Zürich Tourismus» zu verwenden ' +
          'und so zu implementieren, dass die Quellenangabe für Dritte ohne weiteres erkennbar ist. Eine kommerzielle Nutzung ' +
          '(inbesondere für Werbung und andere kommerzielle Verwertungen) des Materials durch Dritte ohne touristischen Hintergrund ist verboten.<br><br>' +
          'Sämtliche Rechte verbleiben bei Zürich Tourismus, resp. dem Inhaber der entsprechenden Rechte. ' +
          'Die Nutzer des Zürich Tourismus Media Center erhalten ausschliesslich das Recht die Bilder, Videos und Audiodateien ' +
          'im Rahmen dieser Nutzungsbestimmungen zu nutzen.<br><br>' +
          'Alle angebotenen digitalen Inhalte sind rechtlich geschützt. Eine sinnentstellende, diskriminierende oder die Interessen ' +
          'von Zürich Tourismus verletzende Verwendung des Materials ist nicht gestattet. Bilder, Videos und Audiodateien des ' +
          'Zürich Tourismus Media Centers dürfen weder bearbeitet noch sonst wie sinnentfremdend verändert, verfälscht oder manipuliert werden.<br><br>' +
          'Die Durchsetzung von Rechtsansprüchen von Zürich Tourismus durch die missbräuchliche Verwendung von Bildern, Videos und/oder Audiodateien ' +
          'aus dem Zürich Tourismus Media Center, insbesondere Verstösse gegen diese Nutzungsbedingungen, bleibt ausdrücklich vorbehalten.' +
          'Bei Fragen zur Verwendung wenden Sie sich bitte an:<br>' +
          'Zürich Tourismus, Gessnerallee 3, 8001 Zürich, E-Mail: <a href="mailto:marketing@zuerich.com">marketing@zuerich.com</a><br><br>',
        en:
          'All the images, videos, and audio files in the Zürich Tourism Media Center are placed at your disposal for ' +
          'editorial purposes free of charge. If you wish to publish any of this material, you must use the source reference, ' +
          '“©Zürich Tourism”, and ensure that this is clearly visible to third parties. Commercial use of the material ' +
          '(in particular for advertising and other commercial purposes) by third parties without a touristic background is prohibited.<br><br>' +
          'All rights remain with Zürich Tourism or with the owner of the corresponding copyright. Users of the Zürich Tourism Media Center ' +
          'are solely given the right to use the images, videos, and audio data within the framework of these Conditions of Use.<br><br>' +
          'All of the digital content provided is protected by law. It is not permitted to use the material in a misleading or discriminatory way, ' +
          'or in a manner that is prejudicial to the interests of Zürich Tourism. Pictures, videos, and audio data provided by the Zürich Tourism ' +
          'Media Center may not be modified, falsified or manipulated in any way, nor is it permitted to alter the central sense.<br><br>' +
          'Zurich Tourism expressly reserves the right to enforce its legal rights as a result of the misuse of images, videos, and/or audio data ' +
          'from the Zürich Tourism Media Center, in particular in the event of violations against these Conditions of Use.<br><br>' +
          'If you have any questions relating to the use of the material, please contact:<br>' +
          'Zürich Tourism, Gessnerallee 3, 8001 Zürich, E-mail: <a href="mailto:marketing@zuerich.com">marketing@zuerich.com</a><br><br>',
      },
      confirm: {
        de: 'Ich habe die Nutzungsbestimmungen des Zürich Tourismus Media Centers gelesen, verstanden und akzeptiere die darin enthaltenen Bedingungen.',
        en: 'I have read, understood and accept the Zürich Tourism Media Center’s Conditions of Use.',
      },
    },
  })
  $('#anura-gallery').anuraGallery({
    server: server,
    locale: locale,
    basket: basket,
    stream: true,
    li_expander: true,
    size: 'big',
    noderef: true,
    recursive: true,
    download_directly: false,
    detail_view: 'details',
    detail_settings: { scrollfix: false, download_directly: false },
    paginate: 16,
    node: { id: 83 },
    sort: { order: 'name', seq: 'asc' },
  })
  $('#anura-tree').anuraSearch({
    server: server,
    locale: locale,
    resettable: false,
    widgets: [
      { name: 'text' },
      {
        name: 'infofield',
        id: 121,
        style: 'tree',
        autosubmit: true,
        tree_settings: { sort: 'name_asc' },
      },
      {
        name: 'keywords',
        title: { de: 'Themen', en: 'Topics' },
        root: 2928,
        autosubmit: true,
        collapsible: true,
        collapsed: true,
        tree_settings: {
          sort: null,
          hide_empty: true,
          data_modifier: function (data) {
            data.sort(function (a, b) {
              return a.name.localeCompare(b.name, undefined, {
                numeric: true,
                sensitivity: 'base',
              })
            })
            $.each(data, function (i, d) {
              d.name = d.name.replace(/^\d+[ _]/, '')
              console.log(d.name)
            }) // 01_Zürich -> Zürich
          },
        },
      },
    ],
  })
}
